module.exports = __webpack_public_path__ + "img/nexus.61aeb57c.png";